export default __webpack_public_path__ + "static/media/topArrow.07a3b8e9.svg";